import * as vp from 'vopay';
import styles from './InterestAccountFundTransferModalError.module.scss';

type InterestAccountFundTransferProps = {
  visible: boolean;
  onClose: () => void;
  errorMessage: string;
  failureReason: string;
};

const InterestAccountFundTransferModalError: React.FC<InterestAccountFundTransferProps> = (
  props: InterestAccountFundTransferProps,
) => {
  const { visible, onClose, errorMessage, failureReason } = props;
  const { Box, Button, Modal } = vp;

  return (
    <Modal isVisible={visible} enableBgClick={false}>
      <div className={styles.container}>
        <Box height="auto" flx="col" jc="fe">
          <Box pb="md" width="100%" jc="sb" className={styles.titleContainer}>
            <h1>Error</h1>
          </Box>
          <Box pb="md">{failureReason}</Box>
          <Box pb="lg">
            <b>{errorMessage}</b>
          </Box>

          <Box width="100%" flx="col" gap="sm" jc="fe">
            <Button
              id="create-interest-account-continue"
              label="Back"
              color="primary"
              type="button"
              onClick={() => {
                onClose();
              }}
            />
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default InterestAccountFundTransferModalError;
